import React from 'react'

const AboutBox = ({ about, nombre }) => {
  return (
    <div className="p-4 mt-4 bg-white">
      <h2 className="block mb-2 font-sans text-sm uppercase">
        Sobre <strong>{nombre}</strong>
      </h2>
      {about && <p>{about}</p>}
    </div>
  )
}

export default AboutBox
